/**
 * Drop-in replacement for `import { toast } from 'sonner'`.
 * Automatically activates the Toaster provider on first use and queues
 * calls until the Toaster is mounted so no toast is lost.
 */
import { toast as sonnerToast } from 'sonner';
import { activateToaster, enqueueToast } from './toast-signal';

export const toast: typeof sonnerToast = new Proxy(sonnerToast, {
	apply(_target, _thisArg, args) {
		activateToaster();
		enqueueToast(() => Reflect.apply(sonnerToast, sonnerToast, args));
	},
	get(target, prop, receiver) {
		const value = Reflect.get(target, prop, receiver);
		if (typeof value === 'function') {
			return function (this: unknown, ...args: unknown[]) {
				activateToaster();
				enqueueToast(() => (value as (...a: unknown[]) => unknown).apply(target, args));
			};
		}
		return value;
	},
});
